<template>
  <section id="main" class="main inner active">
    <div class="main__content">
      <div class="container-fluid p-0 fullheight">
        <div class="row g-0 fullheight">
          <!-- Main Section Intro Start -->
          <div class="col-12 col-xl-8 main__intro">
            <!-- Intro Content Start -->
            <div class="intro__content">
              <!-- Headline Start -->
              <div id="headline" class="headline">
                <span class="headline__subtitle">Let's code with me</span>
                <h1>Stay tuned for something awesome.</h1>
              </div>
              <!-- Headline End -->
            </div>
            <!-- Intro Content End -->

            <!-- Bottom Button Start -->
            <div class="intro__button">
              <a href="#0" id="menu-trigger-intro" class="btn-bottom">
                <span class="circle">
                  <em></em>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                  >
                    <rect fill="none" height="24" width="24" />
                    <path
                      d="M14.29,5.71L14.29,5.71c-0.39,0.39-0.39,1.02,0,1.41L18.17,11H3c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h15.18l-3.88,3.88 c-0.39,0.39-0.39,1.02,0,1.41l0,0c0.39,
                      0.39,1.02,0.39,1.41,0l5.59-5.59c0.39-0.39,0.39-1.02,0-1.41L15.7,5.71 C15.32,5.32,14.68,5.32,14.29,5.71z"
                    />
                  </svg>
                </span>
                <span class="caption">See more</span>
              </a>
            </div>
            <!-- Bottom Button End -->
          </div>
          <!-- Main Section Intro End -->

          <!-- Main Section Media Start -->
          <div class="col-12 col-xl-4 main__media">
            <!-- Main Section Image Background Start -->
            <div class="media__image media-image-1"></div>
            <!-- Main Section Image Background End -->

            <!-- Background Effect Start -->
            <!-- particles background -->
            <div id="particles-js"></div>
            <!-- Background Effect End -->
          </div>
          <!-- Main Section Media End -->

          <!-- Sosials Mobile Start -->
          <div class="col-12 socials-mobile">
            <ul>
              <li>
                <a href="https://www.facebook.com/" target="_blank">
                  <i class="fa-brands fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/" target="_blank">
                  <i class="fa-brands fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="https://www.pinterest.com/" target="_blank">
                  <i class="fa-brands fa-pinterest"></i>
                </a>
              </li>
              <li>
                <a href="https://www.behance.net/" target="_blank">
                  <i class="fa-brands fa-behance"></i>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/" target="_blank">
                  <i class="fa-brands fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="https://dribbble.com/" target="_blank">
                  <i class="fa-brands fa-dribbble"></i>
                </a>
              </li>
            </ul>
          </div>
          <!-- Sosials Mobile End -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MainSection",
};
</script>
